import type { IntlShape } from 'react-intl'

import type { ClientErrorCode } from '@utils/kratos.utils'

// `clientError.*` lives in our own namespace, NOT alongside `kratos.${id}` —
// keeping our discriminants and Kratos's numeric ids in separate prefixes
// avoids future collisions (e.g. a new Kratos ID like `kratos.client.*`).
const KEY_BY_CODE: Record<ClientErrorCode, string> = {
  network: 'clientError.network',
  parse: 'clientError.parse',
  upstream: 'clientError.upstream',
}

// Single-responsibility translation. Logging is a separate concern — callers
// invoke `logClientError` before this so the raw upstream string (which may
// reveal infrastructure naming like "Kratos login flow lookup failed: 500")
// never reaches the user-facing UI.
export const translateClientError = (intl: IntlShape, code: ClientErrorCode): string =>
  intl.formatMessage({ id: KEY_BY_CODE[code] })

// Side-effecting log path kept separate so future swaps to Sentry/PostHog
// only touch this function. The eslint-disable is local because this is the
// one allow-listed call site that intentionally hits the console.
export const logClientError = (code: ClientErrorCode, technicalDetail: string): void => {
  // eslint-disable-next-line no-console
  console.error('[kratos.client]', code, technicalDetail)
}
